import { create, filter, findAll, findOne, getOne, resetSave, update } from "@/store/Crud/functions/actions";
import { IS_LOADING, SET_DATA_ITEM, SET_ERROR, SET_SUCCESS, SET_HAS_ACCOUNT } from "@/store/TenstarSimulator/types";
import axios from "@/utils/axios";
const URL = "/simulator-ten-star/students";
export const findHasAccount = async (store) => {
    store.commit(IS_LOADING, true);
    return await axios
        .get(`${URL}/current/has-account`)
        .then(({ data }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_HAS_ACCOUNT, data);
        store.commit(SET_SUCCESS, true);
    })
        .catch(({ response }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_HAS_ACCOUNT, false);
        store.commit(SET_ERROR, response.data);
        store.commit(SET_SUCCESS, false);
    });
};
export const fetchSimulatorStudent = async (store) => {
    store.commit(IS_LOADING, true);
    return await axios
        .get(`${URL}/current/details`)
        .then(({ data }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_DATA_ITEM, data);
        store.commit(SET_SUCCESS, true);
    })
        .catch(({ response }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_DATA_ITEM, {});
        store.commit(SET_ERROR, response.data);
        store.commit(SET_SUCCESS, false);
    });
};
export const updateStudentPassword = async (store, payload) => {
    store.commit(IS_LOADING, true);
    return await axios
        .put(`${URL}/current/new-password`, "" + payload, {
        headers: { "Content-Type": "text/plain" },
    })
        .then(({ data }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_SUCCESS, true);
        return true;
    })
        .catch(({ response }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_ERROR, response?.data);
        store.commit(SET_SUCCESS, false);
        return false;
    });
};
export default {
    findHasAccount,
    fetchSimulatorStudent,
    updateStudentPassword,
    create,
    filter,
    findOne,
    update,
    findAll,
    getOne,
    resetSave,
};
